import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const StoreIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.30313 1.22146C2.41703 0.936713 2.69281 0.75 2.99949 0.75H14.9995C15.3062 0.75 15.5819 0.936713 15.6958 1.22146L17.2784 5.17791C17.6405 6.0832 17.4323 7.11629 16.7495 7.81051V16.5C16.7495 16.9142 16.4137 17.25 15.9995 17.25H1.99951C1.5853 17.25 1.24951 16.9142 1.24951 16.5V7.81057C0.566675 7.11634 0.358422 6.08322 0.720547 5.17791L2.30313 1.22146ZM13.2639 7.82507C13.8068 8.36802 14.5409 8.60342 15.2495 8.53129V15.75H12.7495V11.5C12.7495 11.0858 12.4137 10.75 11.9995 10.75H5.99951C5.5853 10.75 5.24951 11.0858 5.24951 11.5V15.75H2.74951V8.53129C3.45814 8.60341 4.19214 8.36801 4.73507 7.82507L4.99949 7.56066L5.05494 7.61612C6.12888 8.69006 7.87009 8.69006 8.94403 7.61612L8.99949 7.56066L9.05494 7.61612C10.1289 8.69006 11.8701 8.69006 12.944 7.61612L12.9995 7.56066L13.2639 7.82507ZM6.74951 15.75H11.2495V12.25H6.74951V15.75ZM3.50726 2.25L2.11326 5.735C1.97146 6.08951 2.05457 6.49442 2.32456 6.76441C2.69731 7.13716 3.30166 7.13716 3.67441 6.76441L4.46916 5.96967C4.76205 5.67678 5.23692 5.67678 5.52982 5.96967L6.1156 6.55546C6.60376 7.04361 7.39521 7.04361 7.88337 6.55546L8.46915 5.96967C8.76205 5.67678 9.23692 5.67678 9.52981 5.96967L10.1156 6.55546C10.6038 7.04361 11.3952 7.04361 11.8834 6.55546L12.4692 5.96967C12.762 5.67678 13.2369 5.67678 13.5298 5.96967L14.3246 6.76441C14.6973 7.13716 15.3017 7.13716 15.6744 6.76441C15.9444 6.49442 16.0275 6.08951 15.8857 5.73499L14.4917 2.25H3.50726Z"
        />
      </svg>
    );
  }
);
export default StoreIcon;
